export { default as RecommendSearchWordsCardA } from "./CardA";
export { default as RecommendSearchWordsCardB } from "./CardB";
